export default __webpack_public_path__ + "static/media/free-heart.a7c13142.webp";